import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormGroup, Validators } from '@angular/forms';
import { FirmanteNif } from '../../../models/firmante-nif';
import { FormularioDocumentoService } from '../../../services/formulario-documento.service';
import { DatosConfiguracionDocumentosService } from '../../../services/datos-configuracion-documentos.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormulariosGrupoCasillasComponent } from '../formularios-grupo-casillas/formularios-grupo-casillas.component';

@Component({
  selector: 'app-formularios-firmante',
  templateUrl: './formularios-firmante.component.html',
  styleUrls: ['./formularios-firmante.component.css']
})

export class FormulariosFirmanteComponent implements OnInit {

  @Input() firmante: any;
  @Input() inlineMode = false;
  @Output() firmanteSeleccionado: EventEmitter<FirmanteNif> = new EventEmitter<FirmanteNif>();
  casillasMostrarFormArray: FormArray = new FormArray([]);
  @ViewChild('formulariosGrupoCasillasComponent') formulariosGrupoCasillasComponent: FormulariosGrupoCasillasComponent;

  constructor(public formularioDocumentoService: FormularioDocumentoService,
              private datosConfiguracionDocumentosService: DatosConfiguracionDocumentosService,
              private cdr: ChangeDetectorRef,
              private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.datosConfiguracionDocumentosService.datosArrayFormulariosVacio$.subscribe(() => {
      if (this.firmante) {
        this.mostrarFormularioArrayFirmante();
        this.cdr.detectChanges();
      }
    });
    if (this.inlineMode) {
      this.mostrarFormularioArrayFirmante();
    }
  }

  mostrarEstado(firmanteNuevo: FirmanteNif){
    this.firmanteSeleccionado.emit(firmanteNuevo);
    this.cdr.detectChanges();
    const codigo = this.firmante?.tipoFirmante?.codigo;
    if (codigo && !this.formularioDocumentoService.firmanteTieneBorradoresFormulario(codigo) && this.firmante.seleccionado === true) {
      this.formularioDocumentoService.addFormCasillas(firmanteNuevo);
    }
    this.mostrarFormularioArrayFirmante();
  }

  showNewForm (){
    const borradores = this.getBorradoresActualesFirmante();
    const hayAlgunoSinNombre = borradores.some((b) => !(b.nombre ?? '').trim());
    if (hayAlgunoSinNombre) {
      this._snackBar.open('Se tiene que completar el formulario anterior antes de añadir uno nuevo, añada nombre y campos antes de continuar.','cerrar',{ duration: 4000 });
    } else {
      this.formularioDocumentoService.addFormCasillas(this.firmante);
    }
    this.mostrarFormularioArrayFirmante();
  }

  deleteFormulario({nombre, idNombreFormulario,}: {nombre: string; id?: number; idNombreFormulario: number;}) {
    const idNombreFormularioFinal = this.formularioDocumentoService.resolveIdNombreFormularioForDelete(idNombreFormulario, idNombreFormulario, this.firmante?.tipoFirmante?.codigo, nombre);
    const borradores = this.getBorradoresActualesFirmante();
    const keyFormularioABorrar = String(idNombreFormularioFinal);
    const hayOtroSinNombre = borradores.some(
      (b) => String(b.idNombreFormulario) !== keyFormularioABorrar && !(b.nombre ?? '').trim()
    );
    if (hayOtroSinNombre) {
      this._snackBar.open('Se tiene que completar el formulario nuevo o borrarlo antes de borrar el formulario actual.','cerrar',{ duration: 4000 });
    } else {
      this.formularioDocumentoService.deleteFormularioGrupo(this.firmante?.tipoFirmante?.codigo,idNombreFormularioFinal, nombre);
    }
    this.cdr.detectChanges();
    this.mostrarFormularioArrayFirmante();
  }

  mostrarFormularioArrayFirmante(){
    const codigo = this.firmante?.tipoFirmante?.codigo;
    this.casillasMostrarFormArray = new FormArray([]);
    if (!codigo) {
      return;
    }
    this.formularioDocumentoService.getBorradorFormGroupsForFirmante(codigo).forEach((group) => {
      const nombreControl = group.get('nombre');
      if (nombreControl) {
        nombreControl.setValidators([Validators.maxLength(22)]);
        nombreControl.updateValueAndValidity({ emitEvent: false });
      }
      this.casillasMostrarFormArray.push(group);
    });
  }

  convertirAForm(indice: number): FormGroup {
    return this.casillasMostrarFormArray.at(indice) as FormGroup;
  }

  private getBorradoresActualesFirmante() {
    const codigo = this.firmante?.tipoFirmante?.codigo;
    if (!codigo) {
      return [];
    }
    return this.formularioDocumentoService.getBorradoresForFirmante(codigo);
  }
}

